import { render, staticRenderFns } from "./OfisTercihlerView.vue?vue&type=template&id=04b7fb8c&scoped=true"
import script from "./OfisTercihlerView.vue?vue&type=script&lang=ts"
export * from "./OfisTercihlerView.vue?vue&type=script&lang=ts"
import style0 from "./OfisTercihlerView.vue?vue&type=style&index=0&id=04b7fb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7fb8c",
  null
  
)

export default component.exports